module.exports = __webpack_public_path__ + "static/media/searchSections.d72b8820.jpg";